import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
const HASHKEY = "B@j@j@123%&~";
@Injectable({
  providedIn: 'root'
})
export class AESEncryptionService {
  secretKey = "YourSecretKeyForEncryption&Descryption";
  constructor() { }
  //object encrytpion
  encrypt(valueToEncrypt: any){
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(valueToEncrypt), HASHKEY).toString();
    return ciphertext;
  }
  decrypt(valueToDecrypt: any){
    var bytes  = CryptoJS.AES.decrypt(valueToDecrypt, HASHKEY);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  }

  base64Encode(valueToEncode: any): string {
    const encodedData = btoa(JSON.stringify(valueToEncode));
    return encodedData;
  }

  // Decode data using Base64
  base64Decode(valueToDecode: string): any {
    const decodedData = JSON.parse(atob(valueToDecode));
    return decodedData;
  }

  generateMd5Hash(text:any) { 
    const encodedText = CryptoJS.enc.Utf8.parse(text);
     return CryptoJS.MD5(encodedText).toString(CryptoJS.enc.Hex);
   }
}